module.exports = __webpack_public_path__ + "img/JDH-min.f7b7448b.png";